import { Paginated, Sortable } from "@ac-expo/api-types";

export type UsersFilter = {
  searchText?: string;
  type?: string;
} & Sortable<Paginated>;

export const userQueryKeys = {
  all: ["users"] as const,
  me: () => [...userQueryKeys.all, "me"] as const,
  connect: (connectId: string) =>
    [...userQueryKeys.all, "connect", connectId] as const,
  lists: () => [...userQueryKeys.all, "lists"] as const,
  list: (filters?: UsersFilter) =>
    [...userQueryKeys.lists(), "list", filters] as const,
  details: () => [...userQueryKeys.all, "details"] as const,
  detail: (id: string) => [...userQueryKeys.all, "detail", id] as const,
  purchasesHistory: () => [...userQueryKeys.all, "purchases-history"] as const,
  salesHistory: () => [...userQueryKeys.all, "sales-history"] as const,
  acExpo: () => [...userQueryKeys.all, "ac-expo"] as const,
  byId: (id: string) => [...userQueryKeys.all, id, "byId"] as const,
};

export default userQueryKeys;
